import { Transforms, Editor } from 'slate';

import * as serializer from 'basic-editor-value-serializer';

import { toggleBlock } from '../../3rd-party/rich-text';
import elementTypes from '../../elements/types';
import fieldTypes from '../../elements/ht-form/main/field-types';
import {
  getDefaultOptionsByType
} from '../../elements/ht-form/main/editors/utilities';

import HelptapEditor from '../';

import * as baseNodeUtilities from './base-node';

export function getDefaultOptions() {

  const options = {
    ...serializer.utilities.node.form.getDefaultOptions({}),
    options: {
      formCreated: false,
      formId: null,
      submitButtonLabel: 'Submit',
      successMessage: 'Details are stored successfully!',
      fieldRows: [{
        label: 'Sample label',
        type: fieldTypes.TEXT,
        options: getDefaultOptionsByType(fieldTypes.TEXT)
      }]
    }
  };

  return options;

}

export function insertHTFormNode(editor) {

  const formNode = {
    ...getDefaultOptions(),
    type: elementTypes.FORM
  };

  Transforms.insertNodes(editor, formNode);

}

export function isInsideForm(editor) {

  return true;

}

export function insert(editor, options = {}) {

  const node = {
    ...getDefaultOptions(),
    type: elementTypes.FORM
  };

  if (options.type === elementTypes.SIGNUP_FORM) {
    node.type = elementTypes.SIGNUP_FORM;
    node.properties.signupForm = true;
  }

  HelptapEditor.insertNode(editor, node);

}

export function toggle(editor, options = {}) {

  const nodeOptions = {
    ...getDefaultOptions(),
    type: elementTypes.FORM
  };

  if (options.type === elementTypes.SIGNUP_FORM) {
    nodeOptions.type = elementTypes.SIGNUP_FORM;
    nodeOptions.properties.signupForm = true;
  }

  toggleBlock(editor, nodeOptions.type, nodeOptions);

}

export function cloneNode(node) {

  const formId = node.options.formId;

  if (typeof formId !== 'string') {
    throw Error('Cannot duplicate this node');
  }

  const clonedNode = {
    ...node,
    properties: {
      ...(node.properties || {})
    }
  };

  return clonedNode;

}

export function duplicate(editor, node, nodePath) {

  const clonedNode = cloneNode(HelptapEditor.cloneNode(node));

  HelptapEditor.insertNode(editor, clonedNode, nodePath);

}

export function setBackground(editor, node, nodePath, background) {

  const newProperties = {
    ...(node.properties || {}),
    ...background
  };

  Transforms.setNodes(editor, {
    properties: newProperties
  }, {
    at: nodePath
  });

}

export function setButtonBackground(editor, node, nodePath, background) {

  const newProperties = {
    ...(node.properties || {}),
    submitButtonBackground: background
  };

  Transforms.setNodes(editor, {
    properties: newProperties
  }, {
    at: nodePath
  });

}

export function setButtonHoverBackground(editor, node, nodePath, background) {

  const newProperties = {
    ...(node.properties || {}),
    submitButtonHoverBackground: background
  };

  Transforms.setNodes(editor, {
    properties: newProperties
  }, {
    at: nodePath
  });

}